/**
 * Arrow controls for the scroll-snap rows.
 *
 * Deliberately not a carousel plugin: Slick was tried here three times and
 * broke the page each time, because it makes every child a slide and Horizon
 * renders <style> tags and grid wrappers inside the containers it takes over.
 * The row is a native scroller; these buttons only move scrollLeft.
 */
(function () {
  var ROWS = [
    // The section repeats .group-block-content for its heading row, its
    // stars/rating row, and each card's internal layout before ever reaching
    // the row of review cards itself - a plain class match took the first of
    // those (the heading) instead. :has() picks the row that actually holds
    // 3+ sibling cards.
    { section: 'testimonials_2xY8rM', row: '.group-block-content:has(> .group-block:nth-child(3))' },
    { section: 'product_list_fa6P9H', row: '.resource-list--grid' }
  ];

  function build(row) {
    if (row.dataset.nwArrows === 'true') return;
    row.dataset.nwArrows = 'true';

    var nav = document.createElement('div');
    nav.className = 'nw-arrows';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.setAttribute('aria-label', 'Previous');
    prev.textContent = '\u2039';

    var next = document.createElement('button');
    next.type = 'button';
    next.setAttribute('aria-label', 'Next');
    next.textContent = '\u203a';

    nav.append(prev, next);
    row.parentNode.insertBefore(nav, row);

    function step(dir) {
      // One card per press, measured from the row so it stays right if the
      // card width changes.
      var card = row.firstElementChild;
      var amount = card ? card.getBoundingClientRect().width + 16 : row.clientWidth * 0.8;
      row.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    function sync() {
      prev.disabled = row.scrollLeft <= 4;
      next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    row.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  function init() {
    ROWS.forEach(function (entry) {
      var section = document.querySelector('[id^="shopify-section"][id$="' + entry.section + '"]');
      if (!section) return;

      var row = section.querySelector(entry.row);
      if (row && row.children.length > 1) build(row);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
